// extracted by mini-css-extract-plugin
export default {"MoreButton":"MoreButton_MoreButton__knXbx"};